import React, { Component } from 'react';
import PropTypes from 'prop-types';
import log from 'loglevel';
import { Select, Menu, Button, Header, Modal } from 'semantic-ui-react'
import { ipaFlavourOptions, defaultIpaFlavour } from './Globals';

/*
 * Top of the page menu bar to select different flavours of IPA representation to 
 * query from backend and to show help button.
 */

class MenuBar extends Component {

  constructor(props){
    super(props);
    log.debug('cons props', props);
  }

  componentWillMount(newProps){
    log.debug('newprops: ', newProps);
  }

  handleSelectChange = (e, { value }) => {
    this.props.setIpaFlavour(value);
    this.props.fetchData(this.props.saytext, value);
  }

	render() {

		const IPASelection = () => (
			<Select placeholder='IPA flavour'  
				onChange={this.handleSelectChange}
				defaultValue={this.props.ipaflavour || defaultIpaFlavour}
				options={ipaFlavourOptions} />
		)


    return (
      <div>
        <Menu secondary>
          <Menu.Item>
            <Modal trigger={<Button circular icon="help" color="teal" />} closeIcon='close' >
              <Modal.Header>GaelPhon</Modal.Header>
              <Modal.Content>
                <Modal.Description>

                  <Header>
                    What is this about?
                  </Header>

                  <p>
                    This app will convert Scottish Gaelic words into their pronunciations 
                    using the alphabet of the International Phonetic Association 
                    <a href="https://en.wikipedia.org/wiki/International_Phonetic_Alphabet" target="_blank" rel="noopener noreferrer"> IPA </a> 
                    (especially <a href="https://en.wikipedia.org/wiki/Scottish_Gaelic_phonology" target="_blank" rel="noopener noreferrer"> 
                      Scottish Gaelic Phonology</a>).
                  </p>

                  <p>
                    At the moment, only single words are accepted, without spaces or dashes or other punctuation. 
                    Upper and lower case are not distinguished.
                  </p>

                  <p>
                    To make it easier to enter accented vowels, they can be input by doubling the letter: 
                    lower case vowels "aa", "ee", "ii", "oo" and "uu"
                    are replaced by grave accents "à", "è", "ì", "ò" and "ù" 
                    and upper case vowels "EE" and "OO" by acute accents "é" and "ó".
                    This is possible because there are no Gaelic words which genuinely have double vowels.
                  </p>

                  <p>
                    To quickly jump to the word input field, use the hotkey [Alt]+w or [Alt][Shift]+w (on Firefox) or [Control][Alt]+w.
                    For a list of which modifier keys apart from "w" to use, see:
                    <a href="https://developer.mozilla.org/en-US/docs/Web/HTML/Global_attributes/accesskey" target="_blank" rel="noopener noreferrer"> here </a>
                  </p>

                  <p>
                    The default flavour of phonetic characters is the same as in the Faclair Dictionaries published by 
                    <a href="https://gaelictools.wordpress.com"target="_blank" rel="noopener noreferrer"> gaelictools </a>.
                    There is an option to display alternatives for some characters (notably the velarized liquids) or
                    the choice of characters used in the book "Blas na Gàidhlig" by Michael Bauer.
                    To switch between the flavours, there is a select box on the top right corner of the page.
                  </p>

                  <p>
                    The underlying engine doing the transformation is based on a recurrent artificial neural network
                    that has been trained with around 9,000 words.
                  </p>

                </Modal.Description>
              </Modal.Content>
            </Modal>
          </Menu.Item>
          <Menu.Menu position='right'>
            <Menu.Item name='logout' > 
              <IPASelection />
            </Menu.Item>
          </Menu.Menu>
        </Menu>
      </div>
    );
	}
}


MenuBar.propTypes = {
  saytext: PropTypes.string.isRequired
};


export default MenuBar;



// WEBPACK FOOTER //
// ./src/Menu.js